import { Accordion, Button, Divider, Group, Stack, Text } from '@mantine/core';
import { IconChecks } from '@tabler/icons-react';

import { trpc } from '../../../services/trpc';
import { NotificationGroup } from './notification-group';

export const ModalContent = () => {
  const { data: notifications } = trpc.notifications.list.useQuery();
  const utils = trpc.useUtils();

  const invalidateAll = () => {
    utils.notifications.list.invalidate();
    utils.notifications.activeCount.invalidate();
  };

  const markAsSeen = trpc.notifications.markAsSeen.useMutation({
    onSuccess: invalidateAll,
  });

  const markAsActive = trpc.notifications.markAsActive.useMutation({
    onSuccess: invalidateAll,
  });

  const markAllAsSeen = trpc.notifications.markAllAsSeen.useMutation({
    onSuccess: invalidateAll,
  });

  const active = (notifications ?? []).filter(
    (n: { status: string }) => n.status === 'ACTIVE',
  );
  const seen = (notifications ?? []).filter(
    (n: { status: string }) => n.status === 'SEEN',
  );
  const closed = (notifications ?? []).filter(
    (n: { status: string }) => n.status === 'CLOSED',
  );

  if (!notifications || notifications.length === 0) {
    return (
      <Text c="dimmed" ta="center" py="xl">
        Aucune notification
      </Text>
    );
  }

  return (
    <Stack>
      <Accordion multiple defaultValue={['active']}>
        <NotificationGroup
          label="En cours"
          value="active"
          notifications={active}
          onMarkAsSeen={id => markAsSeen.mutate({ id })}
          footer={
            active.length > 1 && (
              <>
                <Divider mt="xs" />
                <Group justify="flex-end" mt="sm">
                  <Button
                    variant="light"
                    size="xs"
                    leftSection={<IconChecks size={14} />}
                    onClick={() => markAllAsSeen.mutate()}
                    loading={markAllAsSeen.isPending}
                  >
                    Tout marquer comme vu
                  </Button>
                </Group>
              </>
            )
          }
        />
        <NotificationGroup
          label="Vues"
          value="seen"
          notifications={seen}
          onMarkAsActive={id => markAsActive.mutate({ id })}
        />
        <NotificationGroup
          label="Terminées"
          value="closed"
          notifications={closed}
        />
      </Accordion>
    </Stack>
  );
};
